import { DefaultDirections, SortProviderProps, UrlSortProvider } from '@tableau/data-catalog-shared';
import * as React from 'react';

import { FlowOrderField, OrderDirection } from '../../../../gen-src/queries/globalTypes';

export type FlowsValidSortFields = FlowOrderField.NAME | FlowOrderField.PROJECT_NAME |
  FlowOrderField.CONTAINER_NAME;

export const FlowsDefaultDirections: DefaultDirections<FlowsValidSortFields> = {
  [FlowOrderField.NAME]: OrderDirection.ASC,
  [FlowOrderField.PROJECT_NAME]: OrderDirection.ASC,
  [FlowOrderField.CONTAINER_NAME]: OrderDirection.ASC,
};

export const FlowsDefaultSortField = FlowOrderField.NAME;

export function FlowsGridSortProvider(
  props: Pick<SortProviderProps<FlowsValidSortFields>, 'children'>
): JSX.Element {
  return (
    <UrlSortProvider<FlowsValidSortFields>
      validOrderFieldsWithDefaultDirections={FlowsDefaultDirections}
      defaultField={FlowsDefaultSortField}
    >
      {props.children}
    </UrlSortProvider>
  );
}
